import PropTypes from 'prop-types'

export const EtAiText = ({ className = '' }) => (
  <span
    className={`font-bold bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent ${className}`}
  >
    Et Ai
  </span>
)

EtAiText.propTypes = {
  className: PropTypes.string,
}

export default EtAiText
